import React, { useState } from 'react';
import './Bookride.css';
import { Link } from 'react-router-dom';
import logo from '../Assets/images/logo.jpg';

const Bookride = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    pickup: '',
    dropoff: '',
    date: '',
    time: '',
    service: '',
    notes: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const {
      fullName, email, phone, pickup, dropoff, date, time, service, notes,
    } = formData;

    const message = `*New Booking Request - Limoxy World*\n\n
👤 Name: ${fullName}
📧 Email: ${email}
📞 Phone: ${phone}
📍 Pickup Location: ${pickup}
🏁 Drop-off Location: ${dropoff}
📅 Date: ${date}
⏰ Time: ${time}
🚘 Service Type: ${service}
📝 Notes: ${notes || 'None'}

Please confirm availability.`;

    const whatsappNumber = '917025746949'; 
    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    <div className="book-ride-page">

      
      <header className="navbar">
        <div className="top-bar">
          <span>📍 Juffair - bahrain</span>
          <span>📧 support@limoxyworld.com</span>
          <span>⏰ 24/7 Available</span>
        </div>
        <div className="main-nav">
          <div className="logo-container">
            <img src={logo} alt="Limoxy Logo" className="logo-image" />
            <span className="logo-text">LIMOXY</span>
          </div>
          <nav>
            <Link to="/">Home</Link>
            <Link to="/about">About Us</Link>
            <Link to="/services">Our Services</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/partner">Partner</Link>
          </nav>
          
        </div>
      </header>

      <section className="booking-section">
        <h1>Book Your Ride</h1>
        <p>Fill in your ride details and we’ll respond on WhatsApp.</p>

        <form className="booking-formmm" onSubmit={handleSubmit}>
          <input type="text" name="fullName" placeholder="Full Name" required onChange={handleChange} />
          <input type="email" name="email" placeholder="Email Address" required onChange={handleChange} />
          <input type="tel" name="phone" placeholder="Phone Number" required onChange={handleChange} />
          <input type="text" name="pickup" placeholder="Pick Up Location" required onChange={handleChange} />
          <input type="text" name="dropoff" placeholder="Drop Off Location" required onChange={handleChange} />
          <input type="date" name="date" required onChange={handleChange} />
          <input type="time" name="time" required onChange={handleChange} />
          <select name="service" required onChange={handleChange}>
            <option value="">Service Type</option>
            <option>Airport Transfer</option>
            <option>Full Day Chauffeur</option>
            <option>City To City Rides</option>
            <option>Car Rental</option>
            <option>Meet & Greet</option>
          </select>
          <textarea name="notes" rows="5" placeholder="Additional Notes (Optional)" onChange={handleChange}></textarea>
          <button type="submit" className='rrr'>Submit</button>
        </form>
      </section>

      <footer className="footer">
        <div className="footer-content">
          <div className="footer-logo">
            <img src={logo} alt="Limoxy Logo" className="footer-logo-img" />
            <h3>Limoxy World</h3>
          </div>
          <p>Luxury chauffeur services across 45,000+ global locations. Precision. Trust. Class.</p>
          <div className="footer-links">
            <a href="/">Home</a>
            <a href="/about">About</a>
            <a href="/services">Services</a>
            <a href="/contact">Contact</a>
            <a href="/partner">Partner</a>
          </div>
          <p className="footer-bottom">© {new Date().getFullYear()} Limoxy World. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Bookride;